<template>
  <div
    class="msg-mix"
  >
    <div class="msg-c2b-ref" @click="handleRefMsgClick" v-if="isReplayMsg">
      <div class="msg-c2b-ref-meta">
        <div class="msg-c2b-ref-name">{{ formatNickname }}:</div>
        <div class="msg-c2b-ref-time">{{ formatTime }}</div>
      </div>
      <div class="msg-c2b-ref-content">{{ sourceMsg.bytes_summary }}</div>
    </div>
    <template v-for="(item, index) in this.data.content">
      <span
        v-if="item.type === IMSDKType.MSG_TEXT"
        v-html="processedText(item)"
        :key="index"
      ></span>
      <span
        v-else-if="item.type === IMSDKType.MSG_FACE"  :key="index">
        <img  class="emojiText-image" v-if="item.src" :src="item.src"/>
        <span
          v-else-if="item.content"
          v-html="processedText(item)"
        ></span>
    </span>
      <span v-else-if="item.type === IMSDKType.MSG_MEDIA" :key="index">
        <img v-if="item.mediaType === 1" :src="item.mediaUrl" />
      </span>
      <span v-else-if="item.type === IMSDKType.MSG_IMAGE && item._src" :key="index">
        <img :src="item._src" />
      </span>
    </template>
    <msg-text-translate :data="translateData" v-if="isTransLate()"></msg-text-translate>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import { faceIndex } from '@/utils/faceDict';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import MsgTextTranslate from '../MsgTextTranslate';
import globalWin from '@/utils/globalWin';
import dayjs from 'dayjs';

export default {
  inject: ['IMSDKType'],
  props: {
    data: Object,
  },
  components: {
    MsgTextTranslate,
  },
  data() {
    return {
      selectedText: '',
    };
  },
  computed: {
    formatTime() {
      const second = this.sourceMsg?.uint64_time;
      return dayjs(second).format('HH:mm');
    },
    formatNickname() {
      const dir = this.sourceMsg?.uint32_msg_direction;
      if (dir === 1 || dir === '访客') {
        return '我';
      }
      return '客服';
    },
    sourceMsg() {
      /* eslint-disable max-len */
      return this.data.$_sourceMsg || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.qd_source_msg;
    },
    hasMsgId() {
      return this.data?.$_sourceMsg?.str_current_qidian_msg_unique_id || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id;
    },
    isReplayMsg() {
      /* eslint-disable max-len */
      return this.data.$_sourceMsg || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.qd_source_msg?.str_reference_qidian_msg_unique_id;
    },
    translateData() {
      return this.data.content.reduce((total, cur) => total + cur.content, '');
    },
  },
  created() {
    this.formatFacePath();
    this.formatImgPath();
  },
  methods: {
    handleRefMsgClick() {
      this.$emit('onReplayMsgClick', this.sourceMsg?.str_reference_qidian_msg_unique_id);
    },
    formatFacePath() {
      for (let i = 0; i < this.data.content.length; i++) {
        if (this.data.content[i].type === this.IMSDKType.MSG_FACE) {
          const text = Utils.faceTipEscape(this.data.content[i].index);
          const index = faceIndex.indexOf(this.data.content[i].index);
          if (index !== -1) {
            // let emojiUrl = 'https://webpage.qidian.qq.com/qidian/chatClient/release/comp/img/qq/';
            // if (location.hostname === 'oaadmin.qidian.qq.com') {
            //   emojiUrl = 'https://oawebpage.qidian.qq.com/qidian/chatClient/release/comp/img/qq/';
            // }
            this.data.content[i].src = `./static/qq/${index}.png`;
          }
          this.data.content[i].content = text || this.data.content[i].content || this.$t('custom_Face');
        }
      }
    },
    async formatImgPath() {
      for (let i = 0; i < this.data.content.length; i++) {
        if (this.data.content[i].type === this.IMSDKType.MSG_IMAGE) {
          // 获得存储的文件路径
          const data = {
            path: this.data.content[i].content,
            name: this.data.content[i].name,
            size: this.data.content[i].size,
            resStore: this.data.content[i].resStore,
          };
          const src = await SDKUtils.getDownloadUrl(data, IMSDK.OBJTYPES.OBJ_IMAGE);
          // 这里设置一个下划线的特殊属性，避免和后端字段重复
          this.$set(this.data.content[i], '_src', src);
        }
      }
    },
    processedText(item) {
      const { content } = item;
      // 过滤html，仅保留 a ；
      let text = Utils.filterHTML(content);
      text = Utils.emojiEscape(text);
      // 当文本中不包括 a连接时，才进行转义
      if (text.indexOf('<a ') === -1) {
        text = Utils.urlEscape(text);
      }
      return text;
    },
    isTransLate() {
      // const { translateSwitch, translateAuto, isTranslate } = globalWin.translate;
      const { translateSwitch, translateAuto  } = globalWin.translate || {};
      // return +translateSwitch && (+translateAuto || +isTranslate) && !this.data.mine;
      return +translateSwitch && translateAuto && !this.data.mine;
    },
  },
};
</script>

<style lang="less" scoped>
.msg-mix {
  font-family: @emoji-family, "PingFangSC-Regular", "Microsoft YaHei",
    "sans-serif";
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  padding: 10px 15px;
  max-width: 300px;

  &.pc{
    font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  &.pc.pc-not-frame{
     max-width: 460px;
  }

  .emoji {
    font-size: 20px;
    vertical-align: -2px;
  }
  .emojiText-image {
    height: 20px;
    vertical-align: top;
    min-width: 20px;
    max-width: 20px;
  }

  img {
    max-width: 100%;
  }
}

.msg-c2b{
  .msg-mix{
    color: #fff;
    ::v-deep a{
      color: #fff;
    }
  }
}
.msg-c2b-ref {
  opacity: .4;
  cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,.4);
  margin-bottom: 4px;
  padding-bottom: 4px;
  min-width: 130px;
  -webkit-tap-highlight-color: transparent;
  &.b2c {
      border-bottom: 1px solid #CDD0D9;
  }
  &-meta {
      display: flex;
      justify-content: space-between;
  }
  &-name {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
  }
  &-content {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-break: break-all;
  }
}
</style>
